import * as React from "react";

const AwesomeTimesCircle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="34.875" height="34.875" viewBox="0 0 34.875 34.875">
            <path id="Icon_awesome-times-circle" data-name="Icon awesome-times-circle" d="M18,.563A17.438,17.438,0,1,0,35.438,18,17.434,17.434,0,0,0,18,.563Zm8.55,22.015a.845.845,0,0,1,0,1.2L23.766,26.55a.845.845,0,0,1-1.2,0L18,21.938,13.423,26.55a.845.845,0,0,1-1.2,0L9.45,23.766a.845.845,0,0,1,0-1.2L14.063,18,9.45,13.423a.845.845,0,0,1,0-1.2l2.784-2.784a.845.845,0,0,1,1.2,0L18,14.063,22.577,9.45a.845.845,0,0,1,1.2,0l2.784,2.784a.845.845,0,0,1,0,1.2L21.938,18Z" transform="translate(-0.563 -0.563)" fill="#007047" />
        </svg>
    );
};

export default React.memo(AwesomeTimesCircle);